import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUserById = (id, { enabled = true } = {}) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['user', id],
    queryFn: async () => {
      const result = await restClient({ 
        url: `${prefix}/user/${id}`, 
        method: 'get'
      });
      return result;
    },
    enabled: enabled && !!id, // Only fetch if id is provided
    staleTime:0,
    cacheTime: 0
  });
};
